import moment from 'moment';

import { ValidationArguments, ValidatorConstraintInterface, ValidatorConstraint } from 'class-validator';

@ValidatorConstraint({ name: 'TimeRanges' })
export class TimeRangesAreValid implements ValidatorConstraintInterface {
  validate(currentValue: any, args: ValidationArguments) {
    const { start, stop } = {
      ...args.object,
      [args.property as string]: currentValue,
    } as { start: string; stop: string };

    const startTime = moment(start, 'HH:mm');
    const stopTime = moment(stop, 'HH:mm');

    if (!startTime.isValid() || !stopTime.isValid()) {
      return true;
    }

    return startTime.isBefore(stopTime);
  }

  defaultMessage() {
    return 'The end time needs to come after the start time';
  }
}
